<h1 mat-dialog-title>{{ phone | phone }}</h1>
<div mat-dialog-content>
  <p>Scan a QR code with your phone to call or start an SMS.</p>
  <mat-form-field appearance="outline" class="sms-message">
    <mat-label>SMS message</mat-label>
    <textarea matInput [(ngModel)]="message" rows="3" placeholder="Type a message to include in the SMS QR code"></textarea>
    <mat-hint>The SMS QR code updates as you type.</mat-hint>
  </mat-form-field>
  <div class="qr-options">
    <section>
      <h2>Call</h2>
      <qrcode [qrdata]="callUri" [width]="200" [margin]="4" [errorCorrectionLevel]="'M'" [ariaLabel]="'Call ' + (phone | phone)"></qrcode>
      <a mat-stroked-button [href]="callUri">Call on this device</a>
    </section>
    <section>
      <h2>SMS</h2>
      <qrcode [qrdata]="smsUri" [width]="200" [margin]="4" [errorCorrectionLevel]="'M'" [ariaLabel]="'SMS ' + (phone | phone)"></qrcode>
      <a mat-stroked-button [href]="smsUri">SMS on this device</a>
    </section>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
</div>
